<nav class="navbar navbar-expand-sm flex-column">
  <div class="container-fluid d-flex w-100 header-with-tabs-for-desktop">
    <!-- TotalEnergies Logo -->
    <a class="navbar-brand text-primary" href="#">
      <img src="assets/images/te_logo.png" alt="Logo TotalEnergies" />
    </a>
    <!-- RTPCA Logo -->
    <a class="navbar-brand text-primary" href="#">
      <img src="assets/images/rtpca_logo.png" style="height: 48px;width: 48px;" alt="RTPCA TotalEnergies" />
      <span class="navbar-app-name d-flex align-items-center" style="justify-content: center;">{{
        'appName' | translate
      }}</span>
    </a>
    <div class="w-100">
      <div class="container-fluid d-flex pt-2 pe-0">
        <!-- Navbar content -->
        <ul class="navbar-nav ms-auto d-flex flex-row">

          <li class="nav-item ms-md-4 d-flex">
            <span class="navbar-text navbar-app-name d-none d-md-block">
              <rtpca-dbt-runner></rtpca-dbt-runner>
            </span>
          </li>

          <li class="nav-item d-none d-xl-block">
            <div class="dropdown">
              <button class="navbar-text navbar-app-name d-none d-md-block btn dropdown-toggle" type="button" data-bs-toggle="dropdown" aria-expanded="false">
                {{ refinery | uppercase }}
              </button>
              <ul class="dropdown-menu dropdown-menu-end" aria-labelledby="refinery">
                @for (refinery of (connectedUser | async)?.roles ?? [] | extractRole; track refinery) {
                  <li [value]="refinery">
                    <a (click)="onSelect(refinery)" class="dropdown-item">{{refinery}}</a>
                  </li>
                }
              </ul>
            </div>
          </li>

          <li class="nav-item ms-md-4">
            <div class="dropdown">
              <span class="navbar-text text-uppercase">{{
                (connectedUser | async)?.username
              }}</span>
              <button
                class="btn btn-outline-primary btn-circle"
                id="profile"
                data-bs-toggle="dropdown"
                aria-expanded="false"
                >
                <span class="material-icons-outlined">account_circle</span>
              </button>
              <ul
                class="dropdown-menu dropdown-menu-end"
                aria-labelledby="profile"
                >
                <li>
                  <a class="dropdown-item" href="#" (click)="logout()">{{
                    'common.button.logout' | translate
                  }}</a>
                </li>
              </ul>
            </div>
          </li>
          <li class="nav-item">
            <a (click)="help()">
              <button class="btn btn-outline-primary btn-circle">
                <span class="material-icons-outlined">
                  contact_support
                </span>
              </button>
            </a>
          </li>
          <li>
            <div class="dropdown">
              <button
                class="navbar-text navbar-app-name d-none d-md-block btn dropdown-toggle"
                type="button"
                id="powerbiDropdown"
                data-bs-toggle="dropdown"
                aria-expanded="false"
                >
                <img src="assets/images/power-bi-icon.png" style="height: 20px; width: 20px; margin: 0 auto; display: block;" alt="RTPCA PowerBI" />
              </button>
              <ul class="dropdown-menu dropdown-menu-end" aria-labelledby="powerbiDropdown">
                @for (report of powerBiReports; track report.url) {
                  <li>
                    <a
                      target="_blank"
                      rel="noopener noreferrer"
                      class="dropdown-item"
                      [href]="report.url"
                      >
                      {{ report.nameKey | translate | uppercase }}
                    </a>
                  </li>
                }
              </ul>
            </div>
          </li>
          <li class="nav-item d-none d-xl-block">
            <div class="dropdown">
              <button
                class="btn dropdown-toggle"
                type="button"
                id="lang"
                data-bs-toggle="dropdown"
                aria-expanded="false"
                >
                {{ currentLang | uppercase }}
              </button>
              <ul
                class="dropdown-menu dropdown-menu-end"
                aria-labelledby="lang"
                >
                <li>
                  <a
                    (click)="switchLanguage('en')"
                    class="dropdown-item"
                    href="#"
                    >{{ 'language.english' | translate }}</a
                    >
                  </li>
                  <li>
                    <a
                      (click)="switchLanguage('fr')"
                      class="dropdown-item"
                      href="#"
                      >{{ 'language.french' | translate }}</a
                      >
                    </li>
                  </ul>
                </div>
              </li>
            </ul>
          </div>
          <hr class="separator" />
          @if ((connectedUser | async); as user) {
            @if (user?.roles && user.roles.length > 0) {
              @if (extractRole(user.roles)) {
                <div class="container-fluid">
                  <ul class="nav nav-tabs">
                    @for( tab of availableTabs; track tab){
                      @if (showNavbar) {
                        <li>
                          <a class="nav-link" aria-current="page" [routerLink]="tab.route"
                            [ngClass]="{ active: (tabName$ | async) === tab.label }" (click)="onChangeTab(tab.label)">{{
                          'navbar.TAB_LABELS.' + tab.label | translate }}</a>
                        </li>
                      }
                    }
                    @if (!showNavbar) {
                      <li>
                        <a class="nav-link active" aria-current="page"
                          >{{
                        'navbar.TAB_LABELS.' + 'help' | translate }}</a>
                      </li>
                    }
                  </ul>
                </div>
              }
            }
          }
        </div>
      </div>
    </nav>
